import { AdviceTopics } from "../private/adviceCommunication/AdviceTopics";
import { OrchestrationTopics } from "./FilterTypes";
import { EventHistoryTopics } from "./EventHistory";
import { eventQBus as eventQBusRaw } from "@otto-ec/global-resources/event-q-bus";

export type Topics = EventHistoryTopics & OrchestrationTopics & AdviceTopics;

export const eventQBus = eventQBusRaw.with<Topics>();
